<template>
  <el-container style="position: relative;">
    <el-aside width="300px">
      <el-card class="base-card" shadow="never" :body-style="{ padding: '0px' }">
        <div slot="header" class="base-card-header">
          <span>所属部门</span>
        </div>
        <el-scrollbar :style="{height: (getMainContextHeight - 94) + 'px'}" class="custom-scroll">
          <el-tree ref="sysDept" :props="{label: 'name'}"
            :data="StaffPaConfig.sysDept.impl.dropdownList"
            node-key="id" @node-click="onSysDeptValueChange"
            :highlight-current="true" :default-expand-all="true" />
        </el-scrollbar>
      </el-card>
    </el-aside>
    <el-main style="padding-left: 15px;">
      <el-scrollbar :style="{height: (getMainContextHeight - 42) + 'px'}" class="custom-scroll">
        <el-form ref="StaffPaConfigFilter" :model="StaffPaConfig" :size="defaultFormItemSize"
          label-width="100px" label-position="right" @submit.native.prevent
        >
          <filter-box :item-width="350">
            <el-form-item label="登录账号" prop="formFilter.loginName">
              <el-input class="filter-item" v-model="StaffPaConfig.formFilter.loginName"
                :clearable="true" placeholder="登录账号"
              />
            </el-form-item>
            <el-form-item label="姓名" prop="formFilter.showName">
              <el-input class="filter-item" v-model="StaffPaConfig.formFilter.showName"
                :clearable="true" placeholder="姓名"
              />
            </el-form-item>
            <el-form-item label="职位状态" prop="formFilter.jobStatus">
              <el-select class="filter-item" v-model="StaffPaConfig.formFilter.jobStatus" :clearable="true" filterable
                placeholder="职位状态" :loading="StaffPaConfig.jobStatus.impl.loading"
                @visible-change="StaffPaConfig.jobStatus.impl.onVisibleChange"
                @change="onJobStatusValueChange">
                <el-option v-for="item in StaffPaConfig.jobStatus.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="用户状态" prop="formFilter.userStatus">
              <el-select class="filter-item" v-model="StaffPaConfig.formFilter.userStatus" :clearable="true" filterable
                placeholder="用户状态" :loading="StaffPaConfig.userStatus.impl.loading"
                @visible-change="StaffPaConfig.userStatus.impl.onVisibleChange"
                @change="onUserStatusValueChange">
                <el-option v-for="item in StaffPaConfig.userStatus.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="工龄" prop="formFilter.workYears">
              <input-number-range class="filter-item"
                v-model="StaffPaConfig.formFilter.workYears" :clearable="true"
                startPlaceholder="最小值" endPlaceholder="最大值"
              />
            </el-form-item>
            <el-form-item label="邮箱" prop="formFilter.email">
              <el-input class="filter-item" v-model="StaffPaConfig.formFilter.email"
                :clearable="true" placeholder="邮箱"
              />
            </el-form-item>
            <el-form-item label="移动电话" prop="formFilter.mobilePhone">
              <el-input class="filter-item" v-model="StaffPaConfig.formFilter.mobilePhone"
                :clearable="true" placeholder="移动电话"
              />
            </el-form-item>
            <el-form-item label="固定电话" prop="formFilter.landlinePhone">
              <el-input class="filter-item" v-model="StaffPaConfig.formFilter.landlinePhone"
                :clearable="true" placeholder="固定电话"
              />
            </el-form-item>
            <el-form-item label="性别" prop="formFilter.gender">
              <el-select class="filter-item" v-model="StaffPaConfig.formFilter.gender" :clearable="true" filterable
                placeholder="性别" :loading="StaffPaConfig.gender.impl.loading"
                @visible-change="StaffPaConfig.gender.impl.onVisibleChange"
                @change="onGenderValueChange">
                <el-option v-for="item in StaffPaConfig.gender.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
              </el-select>
            </el-form-item>
            <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetStaffPaConfig">重置</el-button>
            <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshStaffPaConfig(true)">查询</el-button>
            <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('UserInfoManage:StaffPaConfig:export')"
              @click="onExportClick()">
              导出
            </el-button>
            <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('UserInfoManage:StaffPaConfig:AddUserInfo')"
              @click="onAddUserInfoClick()">
              添加
            </el-button>
          </filter-box>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-table ref="sysUser" :data="StaffPaConfig.SysUser.impl.dataList" :size="defaultFormItemSize" @sort-change="StaffPaConfig.SysUser.impl.onSortChange"
              header-cell-class-name="table-header-gray"
              highlight-current-row @current-change="StaffPaConfig.SysUser.impl.currentRowChange"
              @row-click="handleRowClick" row-key="id" default-expand-all
            >
              <el-table-column type="selection" width="55px"></el-table-column>
              <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="StaffPaConfig.SysUser.impl.getTableIndex" />
              <el-table-column label="登录账号" prop="loginName" width="110px">
              </el-table-column>
              <el-table-column label="姓名" prop="showName" sortable="custom" width="130px">
              </el-table-column>
              <el-table-column label="所属部门" prop="deptIdDictMap.name" width="130px">
              </el-table-column>
              <el-table-column label="用户类型" prop="userTypeDictMap.name" sortable="custom" width="100px">
              </el-table-column>
              <el-table-column label="用户状态" prop="userStatusDictMap.name" sortable="custom" width="100px">
              </el-table-column>
              <el-table-column label="政治面貌" prop="politicalTypeDictMap.name" sortable="custom" width="100px">
              </el-table-column>
              <el-table-column label="融合岗位" prop="fusionPostDictMap.name" width="110px">
              </el-table-column>
              <el-table-column label="职称" prop="jobTitleIdDictMap.name" width="100px">
              </el-table-column>
              <el-table-column label="薪级" prop="jobLevelIdDictMap.name" width="250px">
              </el-table-column>
              <el-table-column label="绩效组" prop="indexGroupIdDictMap.name" width="250px">
              </el-table-column>
              <el-table-column label="职位状态" prop="jobStatusDictMap.name">
              </el-table-column>
              <el-table-column label="性别" prop="genderDictMap.name">
              </el-table-column>
              <el-table-column label="工龄" prop="workYears">
              </el-table-column>
              <el-table-column label="入职时间" prop="entryTime" width="100px">
                <template slot-scope="scope">
                  <span>{{formatDateByStatsType(scope.row.entryTime, 'day')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="转正时间" prop="regularTime" width="100px">
                <template slot-scope="scope">
                  <span>{{formatDateByStatsType(scope.row.regularTime, 'day')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="出生日期" prop="birthDate" width="100px">
                <template slot-scope="scope">
                  <span>{{formatDateByStatsType(scope.row.birthDate, 'day')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="移动电话" prop="mobilePhone" width="100px">
              </el-table-column>
              <el-table-column label="邮箱" prop="email" width="180px">
              </el-table-column>
              <el-table-column label="固定电话" prop="landlinePhone">
              </el-table-column>
              <el-table-column label="民族" prop="nationTypeDictMap.name">
              </el-table-column>
              <el-table-column label="入党时间" prop="joinPartyTime" width="100px">
                <template slot-scope="scope">
                  <span>{{formatDateByStatsType(scope.row.joinPartyTime, 'day')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="籍贯" prop="hometown">
              </el-table-column>
              <el-table-column label="参加工作时间" prop="joinJobTime" width="100px">
                <template slot-scope="scope">
                  <span>{{formatDateByStatsType(scope.row.joinJobTime, 'day')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="身份证号" prop="idNum" width="180px">
              </el-table-column>
              <el-table-column label="最高学历" prop="educationLvMaxDictMap.name">
              </el-table-column>
              <el-table-column label="毕业院校" prop="educationSchoolMax">
              </el-table-column>
              <el-table-column label="专业" prop="educationMajorMax">
              </el-table-column>
              <el-table-column label="毕业时间" prop="educationTimeMax" width="100px">
                <template slot-scope="scope">
                  <span>{{formatDateByStatsType(scope.row.educationTimeMax, 'day')}}</span>
                </template>
              </el-table-column>

              <el-table-column label="现有职称" prop="jobTitleNameNow">
              </el-table-column>
              <el-table-column label="职称级别" prop="jobTitleLvNowDictMap.name">
              </el-table-column>
              <el-table-column label="取得时间" prop="jobTitleTimeNow" width="100px">
                <template slot-scope="scope">
                  <span>{{formatDateByStatsType(scope.row.jobTitleTimeNow, 'day')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                  <el-button @click.stop="onEditUserInfoClick(scope.row)" type="text" :size="defaultFormItemSize"
                    :disabled="!checkPermCodeExist('UserInfoManage:StaffPaConfig:EditUserInfo')">
                    编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex" justify="end" style="margin-top: 10px;">
              <el-pagination
                :total="StaffPaConfig.SysUser.impl.totalCount"
                :current-page="StaffPaConfig.SysUser.impl.currentPage"
                :page-size="StaffPaConfig.SysUser.impl.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, prev, pager, next, sizes"
                @current-change="StaffPaConfig.SysUser.impl.onCurrentPageChange"
                @size-change="StaffPaConfig.SysUser.impl.onPageSizeChange">
              </el-pagination>
            </el-row>
          </el-col>
        </el-row>
        <label v-if="closeVisible == '1'" class="page-close-box">
          <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
        </label>
      </el-scrollbar>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysUserController, DictionaryController } from '@/api';
import addUserInfo from '@/views/UserInfo/addUserInfo.vue';

export default {
  name: 'UserInfoManage',
  props: {
    deptId: {
      default: undefined
    },
    showName: {
      default: undefined
    },
    loginName: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      StaffPaConfig: {
        formFilter: {
          sysDept: undefined,
          loginName: undefined,
          showName: undefined,
          jobStatus: undefined,
          userStatus: undefined,
          workYears: [],
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          gender: undefined
        },
        formFilterCopy: {
          sysDept: undefined,
          loginName: undefined,
          showName: undefined,
          jobStatus: undefined,
          userStatus: undefined,
          workYears: [],
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          gender: undefined
        },
        sysDept: {
          impl: new DropdownWidget(this.loadSysDeptDropdownList, true, 'id', 'parentId')
        },
        jobStatus: {
          impl: new DropdownWidget(this.loadJobStatusDropdownList)
        },
        userStatus: {
          impl: new DropdownWidget(this.loadUserStatusDropdownList)
        },
        SysUser: {
          impl: new TableWidget(this.loadSysUserWidgetData, this.loadSysUserVerify, true, true, 'showName', 1)
        },
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.sysUser.clearSelection();
      }
      this.$refs.sysUser.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetStaffPaConfig () {
      this.$refs.StaffPaConfigFilter.resetFields();
      this.refreshStaffPaConfig(true);
    },
    /**
     * 员工列表数据获取函数，返回Promise
     */
    loadSysUserWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysUserDtoFilter: {
          loginName: this.StaffPaConfig.formFilterCopy.loginName,
          deptTid: this.StaffPaConfig.formFilterCopy.sysDept,
          showName: this.StaffPaConfig.formFilterCopy.showName,
          userStatus: this.StaffPaConfig.formFilterCopy.userStatus,
          gender: this.StaffPaConfig.formFilterCopy.gender,
          jobStatus: this.StaffPaConfig.formFilterCopy.jobStatus,
          workYearsStart: Array.isArray(this.StaffPaConfig.formFilterCopy.workYears) ? this.StaffPaConfig.formFilterCopy.workYears[0] : undefined,
          workYearsEnd: Array.isArray(this.StaffPaConfig.formFilterCopy.workYears) ? this.StaffPaConfig.formFilterCopy.workYears[1] : undefined,
          email: this.StaffPaConfig.formFilterCopy.email,
          mobilePhone: this.StaffPaConfig.formFilterCopy.mobilePhone,
          landlinePhone: this.StaffPaConfig.formFilterCopy.landlinePhone
        }
      }
      return new Promise((resolve, reject) => {
        SysUserController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.StaffPaConfig.SysUser.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.StaffPaConfig.SysUser.impl.currentRow.userId, 'userId');
              this.$refs.sysUser.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 员工列表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysUserVerify () {
      this.StaffPaConfig.formFilterCopy.loginName = this.StaffPaConfig.formFilter.loginName;
      this.StaffPaConfig.formFilterCopy.sysDept = this.StaffPaConfig.formFilter.sysDept;
      this.StaffPaConfig.formFilterCopy.showName = this.StaffPaConfig.formFilter.showName;
      this.StaffPaConfig.formFilterCopy.userStatus = this.StaffPaConfig.formFilter.userStatus;
      this.StaffPaConfig.formFilterCopy.gender = this.StaffPaConfig.formFilter.gender;
      this.StaffPaConfig.formFilterCopy.jobStatus = this.StaffPaConfig.formFilter.jobStatus;
      this.StaffPaConfig.formFilterCopy.workYears = this.StaffPaConfig.formFilter.workYears;
      this.StaffPaConfig.formFilterCopy.email = this.StaffPaConfig.formFilter.email;
      this.StaffPaConfig.formFilterCopy.mobilePhone = this.StaffPaConfig.formFilter.mobilePhone;
      this.StaffPaConfig.formFilterCopy.landlinePhone = this.StaffPaConfig.formFilter.landlinePhone;
      return true;
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadSysDeptDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDept(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属部门选中值改变
     */
    onSysDeptValueChange (value) {
      if (value.id !== this.StaffPaConfig.formFilter.sysDept) {
        this.StaffPaConfig.formFilter.sysDept = value.id;
      } else {
        this.StaffPaConfig.formFilter.sysDept = undefined;
        this.$nextTick(() => {
          this.$refs.sysDept.setCurrentKey(null);
        });
      }
      this.refreshStaffPaConfig(true);
    },
    /**
     * 职位状态下拉数据获取函数
     */
    loadJobStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 职位状态选中值改变
     */
    onJobStatusValueChange (value) {
    },
    /**
     * 用户状态下拉数据获取函数
     */
    loadUserStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysUserStatus(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 用户状态选中值改变
     */
    onUserStatusValueChange (value) {
    },
    /**
     * 性别下拉数据获取函数
     */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGender(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 性别选中值改变
     */
    onGenderValueChange (value) {
    },
    /**
     * 更新员工绩效配置
     */
    refreshStaffPaConfig (reloadData = false) {
      if (reloadData) {
        this.StaffPaConfig.SysUser.impl.refreshTable(true, 1);
      } else {
        this.StaffPaConfig.SysUser.impl.refreshTable();
      }
      if (!this.StaffPaConfig.isInit) {
        // 初始化下拉数据
        this.StaffPaConfig.sysDept.impl.onVisibleChange(true);
      }
      this.StaffPaConfig.isInit = true;
    },
    /**
     * 编辑
     */
    onEditUserInfoClick (row) {
      let params = {
        userId: row.userId
      };

      params.closeVisible = 1;
      this.$router.push({name: 'EditUserInfo', query: params});
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        sysUserDtoFilter: {
          loginName: this.StaffPaConfig.formFilterCopy.loginName,
          deptTid: this.StaffPaConfig.formFilterCopy.sysDept,
          showName: this.StaffPaConfig.formFilterCopy.showName,
          userStatus: this.StaffPaConfig.formFilterCopy.userStatus,
          gender: this.StaffPaConfig.formFilterCopy.gender,
          jobStatus: this.StaffPaConfig.formFilterCopy.jobStatus,
          workYearsStart: Array.isArray(this.StaffPaConfig.formFilterCopy.workYears) ? this.StaffPaConfig.formFilterCopy.workYears[0] : undefined,
          workYearsEnd: Array.isArray(this.StaffPaConfig.formFilterCopy.workYears) ? this.StaffPaConfig.formFilterCopy.workYears[1] : undefined,
          email: this.StaffPaConfig.formFilterCopy.email,
          mobilePhone: this.StaffPaConfig.formFilterCopy.mobilePhone,
          landlinePhone: this.StaffPaConfig.formFilterCopy.landlinePhone
        }
      };

      SysUserController.export(this, params, '员工列表.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    /**
     * 添加
     */
    onAddUserInfoClick () {
      let params = {};

      this.$dialog.show('添加', addUserInfo, {
        area: ['1000px', '700px']
      }, params).then(res => {
        this.refreshStaffPaConfig();
      }).catch(e => {});
    },
    onResume () {
      this.refreshStaffPaConfig();
    },
    initFormData () {
    },
    formInit () {
      this.refreshStaffPaConfig();
    }
  },
  computed: {
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style scoped>
  >>> .el-tree-node__content {
    height: 35px;
  }
</style>
